import React from 'react';
import classNames from 'classnames/bind';

import styles from './styles.pcss';
const cx = classNames.bind(styles);

const LinkButton = (props) => (
  <button {...props} type="button" className={cx('btn')}>
    {props.children}
  </button>
);

export default LinkButton;
